<i18n>
{
	"en": {
		"customer": "Customer",
		"customerMissing": "Customer missing",
		"to": "To",
		"toMissing": "Delivery party missing",
		"from": "From",
		"fromMissing": "Despatch party missing"
	},
		"no": {
		"customer": "Kunde",
		"customerMissing": "Kunde mangler",
		"to": "Til",
		"toMissing": "Mottaker mangler",
		"from": "Fra",
		"fromMissing": "Henteaddresse mangler"
	}
}
</i18n>
<template>
	<div  class="map-modal-trip-info-container">
		<div class="map-modal-info">
			<div class="map-modal-info-labels">
				{{$t('customer')}}
			</div>
			<div class="map-modal-info-data-item" :class="{missing: customerMissing}">
				{{customerName}}
			</div>
		</div>
		<div class="map-modal-info">
			<div class="map-modal-info-labels">
				{{$t('from')}}
			</div>
			<div v-if="despatchPartyMissing" class="map-modal-info-data-item missing">
				{{ $t('fromMissing') }}
			</div>
			<div v-else class="map-modal-info-data-item">
				<div class="item-main-text">{{ order.despatchParty.name }}</div>
				<div class="item-sub-text">{{ order.despatchParty.postalPlace }} {{ order.despatchParty.postalCode }}</div>
			</div>
		</div>
		<div class="map-modal-info">
			<div class="map-modal-info-labels">
				{{$t('to')}}
			</div>
			<div v-if="deliveryPartyMissing" class="map-modal-info-data-item missing">
				{{ $t('toMissing') }}
			</div>
			<div v-else class="map-modal-info-data-item">
				<div class="item-main-text">{{ order.deliveryParty.name }}</div>
				<div class="item-sub-text">{{ order.deliveryParty.postalPlace }} {{ order.deliveryParty.postalCode }}</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'MapModalTooltip',
	props: {
		order: {
			type: Object,
			required: true
		},
	},
	computed: {
		customerName() {
			return this.customerMissing ? this.$t('customerMissing') : this.order.customer.name;
		},
		customerMissing() {
			return !this.order.customer || !this.order.customer.name;
		},
		deliveryPartyMissing() {
			return !this.order.deliveryParty || !this.order.deliveryParty.name;
		},
		despatchPartyMissing() {
			return !this.order.despatchParty || !this.order.despatchParty.name;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.map-modal-trip-info-container{
	display: flex;
	flex-direction: column;
	padding: 8px 10px 8px 10px;
}
.map-modal-info {
	display: flex;
	flex-direction: row;
	.map-modal-info-data-item, .map-modal-info-labels {
		flex: 1;
		line-height: 16px;
		color: get-color($text, 'dark');
	}
	.map-modal-info-labels {
		@extend %text-xsmall;
		flex-grow: 1;
	}
	.map-modal-info-data-item {
		@extend %text-small;
		font-weight: 600;
		flex-grow: 3;
		&.missing {
			font-style: italic;
			color: get-color($text, 'light');
		}
		.item-sub-text {
			height:16px;
			font-size: 10px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.6;
			letter-spacing: normal;
		}
	}
}
</style>
